/**
 * MobileBanner - Gentle recommendation to use desktop
 * Shows once on mobile devices, dismissible, saved to localStorage
 */
import React, { useState, useEffect } from 'react';

const MobileBanner = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const isMobile = window.innerWidth < 768;
    const dismissed = localStorage.getItem('vowai_mobile_banner_dismissed');
    if (isMobile && !dismissed) setShow(true);
  }, []);

  const dismiss = () => {
    setShow(false);
    localStorage.setItem('vowai_mobile_banner_dismissed', '1');
  };

  if (!show) return null;

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-[9999] flex items-center justify-center p-6" onClick={dismiss}>
      <div className="bg-gradient-to-br from-white via-rose-50 to-pink-50 rounded-2xl shadow-2xl p-6 max-w-sm border border-rose-100 text-center" onClick={e => e.stopPropagation()}>
        <div className="inline-flex items-center justify-center w-14 h-14 bg-gradient-to-br from-rose-400 to-pink-500 rounded-full mb-4 shadow-lg">
          <span className="text-2xl">🖥️</span>
        </div>
        <h3 className="text-lg font-serif font-bold bg-gradient-to-r from-rose-600 via-pink-600 to-purple-600 bg-clip-text text-transparent mb-3">
          Best on Desktop
        </h3>
        <p className="text-sm text-gray-600 leading-relaxed mb-5">
          For the best experience, we recommend viewing VowAI on a desktop browser. Our multi-model AI architecture, real-time dashboards, and interactive features are optimized for larger screens.
        </p>
        <button
          onClick={dismiss}
          className="bg-gradient-to-r from-rose-500 via-pink-500 to-purple-500 text-white py-3 px-8 rounded-xl font-bold text-sm hover:shadow-xl transform hover:scale-105 transition-all duration-300"
        >
          Got it 👍
        </button>
      </div>
    </div>
  );
};

export default MobileBanner;
